module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"display":"display"},"ja":{"display":"表示"},"zh-hant":{"display":"顯示"},"zh-hans":{"display":"显示"}}')
  delete Component.options._Ctor
}
